var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckDouble = function SvgCheckDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.596 9.161 3.162 2.414 5.077-5.803-1.004-.877-4.256 4.864L2.404 8.1zm12.906-3.389-1.004-.877-4.246 4.852-.502-.401-.834 1.041 1.498 1.199z"
  })));
};
export default SvgCheckDouble;